import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cliente_docs_token";

// NOTE: Bearer token is intentionally stored in localStorage because this is an
// internal single-admin tool with no public registration and auto-login bypass.
// XSS risk is minimized because the frontend doesn't render arbitrary user-provided
// HTML and there are no third-party scripts loaded. For multi-user scenarios,
// switch to httpOnly cookies via the existing /auth/login Set-Cookie flow.
export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    console.warn("localStorage read failed:", e);
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    console.warn("localStorage write failed:", e);
  }
}

export const api = axios.create({
  baseURL: API,
  // withCredentials false because we use Bearer tokens in localStorage,
  // not cookies. This avoids CORS preflight credential mismatch when the
  // backend runs on a different subdomain in production.
  withCredentials: false,
});

// Attach Bearer token from localStorage as a robust fallback to cookies
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function fileUrl(storagePath, token) {
  if (!storagePath) return null;
  const t = token ? `?auth=${encodeURIComponent(token)}` : "";
  return `${API}/files/${storagePath}${t}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getReadableError(err) {
  const detail = err?.response?.data?.detail;
  const apiMsg = formatApiErrorDetail(detail);
  if (apiMsg) return apiMsg;
  const status = err?.response?.status;
  if (status === 401) return "No autorizado. Revisa que estés conectado.";
  if (status === 403) return "Acceso denegado.";
  if (status === 404) return "Recurso no encontrado.";
  if (status === 0 || err?.code === "ERR_NETWORK") {
    return "Sin conexión al servidor. Verifica tu internet o intenta de nuevo.";
  }
  if (err?.message) return err.message;
  return "Error inesperado. Inténtalo de nuevo.";
}
